import { render } from "./AdminWork.vue?vue&type=template&id=4ab57fbc"
import script from "./AdminWork.vue?vue&type=script&lang=js"
export * from "./AdminWork.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Miftah Faridl\\Documents\\KIM-APPS\\motul-power-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__